var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpo3D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-dfb4e515-18f4-4e0e-a58c-73c214f2c7f3",
    "data-name": "art",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-0aa4b839-4029-417a-b4c3-ebd50dbd58cf",
    x1: 52.5,
    y1: 23.94,
    x2: 52.5,
    y2: 52.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-fd7efab0-5883-41aa-b1d2-da5f4de15258",
    x1: 65,
    y1: 38.22,
    x2: 65,
    y2: 81.06,
    xlinkHref: "#uuid-0aa4b839-4029-417a-b4c3-ebd50dbd58cf"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-7109f458-9360-4dd1-9d46-b095a5a3ea3a",
    x1: 40,
    y1: 38.22,
    x2: 40,
    y2: 81.06,
    xlinkHref: "#uuid-0aa4b839-4029-417a-b4c3-ebd50dbd58cf"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m77.23,38.22c-.17-.3-.42-.55-.73-.73l-23-13.28c-.62-.36-1.38-.36-2,0l-23,13.28c-.31.18-.56.43-.73.73l24.73,14.28,24.73-14.28Z",
    fill: "url(#uuid-0aa4b839-4029-417a-b4c3-ebd50dbd58cf)",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m52.5,52.5v28.56c.35,0,.69-.09,1-.27l23-13.28c.62-.36,1-1.02,1-1.73v-26.56c0-.36-.1-.7-.27-1l-24.73,14.28Z",
    fill: "url(#uuid-fd7efab0-5883-41aa-b1d2-da5f4de15258)",
    opacity: 0.25,
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m27.77,38.22c-.17.3-.27.64-.27,1v26.56c0,.71.38,1.37,1,1.73l23,13.28c.31.18.65.27,1,.27v-28.56l-24.73-14.28Z",
    fill: "url(#uuid-7109f458-9360-4dd1-9d46-b095a5a3ea3a)",
    opacity: 0.5,
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpo3D);
export default __webpack_public_path__ + "static/media/expo_3d.5cf0da9d88f0b2ad85c47a617f901998.svg";
export { ForwardRef as ReactComponent };